module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 44-f86135d686f9c547c7187caee7ca2663.png";